import { render, staticRenderFns } from "./widgetSysResource.vue?vue&type=template&id=0da60be5&scoped=true&"
import script from "./widgetSysResource.vue?vue&type=script&lang=js&"
export * from "./widgetSysResource.vue?vue&type=script&lang=js&"
import style0 from "./widgetSysResource.vue?vue&type=style&index=0&id=0da60be5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da60be5",
  null
  
)

export default component.exports